import { gql } from 'apollo-angular';

export const subDomainMinimalFragment = gql`
  fragment SubDomainMinimal on SubDomain {
    id
    title
  }
`;

export const subDomainItemFragment = gql`
  fragment SubDomainItem on SubDomain {
    ...SubDomainMinimal
    parentDomain {
      id
      title
    }
  }

  ${subDomainMinimalFragment}
`;

export const subDomainDetailFragment = gql`
  fragment SubDomainDetailFragment on SubDomain {
    ...SubDomainItem

    order
  }
  ${subDomainItemFragment}
`;
